import request from '../utils/request'

export function getList (data) {
  return request({
    url: '/app/wap/getList',
    method: 'post',
    data
  })
}

export function getFirmList (data) {
  return request({
    url: '/app/wap/getFirmList',
    method: 'post',
    data
  })
}
